export const themeData = [
    {
        name: 'Analyzing or Calculating',
        desc: 'A job function where you get to calculate or interpret the meaning of numbers or data.',
        videoID: "68a10bcb9deb1fdadc13bcdc"
    },
    {
        name: 'Artistic Creation',
        desc: 'A job function where you get to be creative from an artistic perspective.',
        videoID: "68b6cd346a218061ab315ba2"
    },
    {
        name: 'Chronicling or Documenting',
        desc: 'A job function where you get to record and report facts, observations, or conclusions about people, events, places, or processes.',
        videoID: "68a10bcb396b42f2f680ba9c"
    },
    {
        name: 'Coaching or Mentoring',
        desc: 'A job function where you get to work with individuals to improve their performance and move them closer to becoming the best they can be in a specific activity or area of their life.',
        videoID: "68a10bcb9deb1fdadc13bce8"
    },
    {
        name: 'Competition',
        desc: 'A job function where you get to pit your skills or knowledge against those of others in a quest to be the best, because you love to win.',
        videoID: "68a10bd5396b42f2f680bb0e"
    },
    {
        name: 'Designing',
        desc: 'A job function where you get to be a creator of things from the perspective of form, function, and beauty.',
        videoID: "68a10bd69deb1fdadc13bd61"
    },
    {
        name: 'Entertaining',
        desc: 'A job function where you get to perform and connect with an audience on an emotional level to make them feel happiness, sadness, love, fear, anxiety, excitement, or awe.',
        videoID: "68a10bd89deb1fdadc13bd80"
    },
    {
        name: 'Evaluating or Judging',
        desc: 'A job function that involves a process of evaluating or judging to determine quality, worth, appropriateness, or best option.',
        videoID: "68a10be09deb1fdadc13bdc7"
    },
    {
        name: 'Exploring or Adventuring',
        desc: 'A job function where you get to be outdoors and go boldly where few have gone before.',
        videoID: "68a10be02517393e587d4bb6"
    },
    {
        name: 'Fabricating or Fixing',
        desc: 'A job function where you get to work with your hands and use tools to either build, install, assemble, repair, or restore things.',
        videoID: "68a10be5396b42f2f680bbba"
    },
    {
        name: 'Healing or Caring',
        desc: 'A job function where you get to care for the well-being of people, plants, or animals.',
        videoID: "68a10be82517393e587d4c00"
    },
    {
        name: 'Helping or Serving',
        desc: 'A job function where you get to be helpful and supportive in attending to the needs of others.',
        videoID: "68a10bec396b42f2f680bc2f"
    },
    {
        name: 'Improving or Perfecting',
        desc: 'A job function where your primary focus is on making improvements to products, services, systems, procedures, processes, results, or relationships.',
        videoID: "68a10bed2517393e587d4c3f"
    },
    {
        name: 'Investigating or Fact Finding',
        desc: 'A job function that involves the process of fact finding and deductive reasoning to plot strategy or solve mysteries and complex problems.',
        videoID: "68a10bf62517393e587d4ca3"
    },
    {
        name: 'Leading or Controlling',
        desc: 'A job function where you get to be in charge and in control of situations and their outcomes.',
        videoID: "68a10bf62517393e587d4cb1"
    },
    {
        name: 'Organizing or Coordinating',
        desc: 'A job function where you get to organize and coordinate, itineraries, events, people, projects, or information.',
        videoID: "68a10bfa2517393e587d4ce2"
    },
    {
        name: 'Persuading',
        desc: 'A job function where you get to influence people in terms of their beliefs, attitudes, motivations, or behaviors.',
        videoID: "68a10bff9deb1fdadc13bf45"
    },
    {
        name: 'Science',
        desc: 'A job function that requires an adherence to the scientific method while conducting experiments to validate a hypothesis.',
        videoID: "68a10bff2517393e587d4d28"
    },
    {
        name: 'Socializing',
        desc: 'A job function where you get to work closely with others because you thrive on the camaraderie and sense of community that happens with social interaction.',
        videoID: "68a10bff2517393e587d4d36"
    },
    {
        name: 'Storytelling',
        desc: 'A job function where you create and communicate stories that connect on an emotional level to make audiences feel happiness, sadness, love, fear, anxiety, excitement, or awe.',
        videoID: "68a10c069deb1fdadc13bf8b"
    },
    {
        name: 'Teaching or Training',
        desc: 'A job function where you get to educate people with knowledge or how-to skills that were previously unknown to them.',
        videoID: "68a10c089deb1fdadc13bfa4"
    }
]